import { scheme } from "@starrez/starrytheme";
import styled from "styled-components";

export const ErrorDisplayDiv = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

export const ErrorMessageTitleH2 = styled.h2`
    font-size: 18px !important;
    line-height: 1.6em;
    font-weight: 700;
    margin: 16px 0;
`;

export const ErrorMessageP = styled.p`
    font-size: 18px !important;
    line-height: 1.6em;
`;

export const ErrorStackDiv = styled.div`
    ${scheme.Red.Lighter}
    margin-top: 16px;
`;

export const ErrorStackPre = styled.pre`
    white-space: pre-wrap;
`;
